class ColorSwatches {
    constructor() {
        this.options = {
            limit: window.swatchesRequestLimit || 250,
            visibleElements: 3,
            swatchSelectorPDP:
                ".product-main-color-swatches:not(.is-loaded)",
            swatchSelectorPOP: ".product-card-color-swatches:not(.is-loaded)",
            swatchCollectionAllCollecion: "collections/all?view=color-swatches",
            sessionStorageColor: "colorSwatchesData",
        };

        this.products = null;
        this.totalProducts = window.totalProducts;
        this.dataShowOnlyAvailableColors = window.dataShowOnlyAvailableColors || false;
        this.sessionStorageLangKey = `${this.options.sessionStorageColor}`;

        this.registerEvents();
    }

    async registerEvents() {
        try {
            this.products = await this.getAllColors();

            this.applyColorsProductMain();
            this.applyColorsCardProduct();

            const events = [
                "product-grid-updated",
                "recommended-products-loaded",
            ];

            events.forEach((event) => {
                document.addEventListener(event, () => {
                    this.applyColorsCardProduct();
                });
            });
        } catch (error) {
            console.error(error);
        }
    }

    getCachedColors() {
        const colors = sessionStorage.getItem(this.sessionStorageLangKey);

        return colors ? JSON.parse(colors) : null;
    }

    saveColorsToCache(colors) {
        Object.keys(sessionStorage).forEach((key) => {
            if (key.startsWith(this.options.sessionStorageColor)) {
                sessionStorage.removeItem(key);
            }
        });

        sessionStorage.setItem(this.sessionStorageLangKey, JSON.stringify(colors));
    }

    async getAllColors() {
        const cachedColors = this.getCachedColors();

        if (cachedColors) {
            return cachedColors;
        }

        return await this.fetchAllColors();
    }

    async fetchAllColors() {
        const totalPages = Math.ceil(this.totalProducts / this.options.limit);

        const urls = Array.from(
            {length: totalPages},
            (_, i) =>
                `${window.location.origin}/${this.options.swatchCollectionAllCollecion}&page=${i + 1}`,
        );

        const results = await Promise.allSettled(
            urls.map((url) =>
                fetch(url)
                    .then((res) => {
                        if (!res.ok) throw new Error(`${res.status}`);

                        return res.json();
                    })
                    .catch((error) => {
                        console.warn(error);

                        return { products: [] };
                    })
            )
        );

        const successfulResponses = results
            .filter((result) => result.status === "fulfilled")
            .map((result) => result.value);

        const allProducts = successfulResponses.flatMap((data) => data.products || []);

        this.saveColorsToCache(allProducts);

        return allProducts;
    }

    applyColorsProductMain() {
        const colorSwatchPDP = document.querySelector(
            this.options.swatchSelectorPDP,
        );

        if (!colorSwatchPDP) return;

        this.insertHTMLToProductMainElement(colorSwatchPDP);

        colorSwatchPDP.classList.add("is-loaded");
    }

    applyColorsCardProduct() {
        const colorSwatches = document.querySelectorAll(
            this.options.swatchSelectorPOP,
        );

        if (!colorSwatches.length) return;

        colorSwatches.forEach((colorSwatch) => {
            this.insertHTMLToCardProductElement(colorSwatch);

            colorSwatch.classList.add("is-loaded");
        });

        document.dispatchEvent(new CustomEvent("color-swatches-loaded"));
    }

    insertHTMLToProductMainElement(colorSwatch) {
        const colorCode = colorSwatch.dataset.colorCode,
            colorCodeCurrent = colorSwatch.dataset.colorCodeCurrent;

        const items = this.products.filter(product => {
            const matchesColor = product.color_code === colorCode;
            const matchesAvailability = this.dataShowOnlyAvailableColors === 'true'
                ? product.available === true
                : true;

            return matchesColor && matchesAvailability;
        });

        if (!items.length) return;

        let html = items
            .map((item) => {
                const activeClass = item.color_code_current === colorCodeCurrent ? ' active' : '';

                return this.swatchItemHtml(item, activeClass)
            })
            .join('');

        colorSwatch.insertAdjacentHTML('beforeend', html);
    }

    insertHTMLToCardProductElement(colorSwatch) {
        const colorCode = colorSwatch.dataset.colorCode;
        const items = this.products.filter(product => {
            const matchesColor = product.color_code === colorCode;
            const matchesAvailability = this.dataShowOnlyAvailableColors === 'true'
                ? product.available === true
                : true;

            return matchesColor && matchesAvailability;
        });

        if (!items.length) return;

        let html = items
            .map((item, index) => {
                const additionalClass = index >= this.options.visibleElements ? ' color-variant--hidden' : '';

                return this.swatchItemHtml(item, additionalClass);
            })
            .join('');

        if (items.length > this.options.visibleElements) {
            const showMoreValue = items.length - this.options.visibleElements;
            const spanHtml = `
                <span class="text-xs text-gray-medium-200">+ ${showMoreValue}</span>
            `
            html += spanHtml;
        }

        colorSwatch.insertAdjacentHTML('beforeend', html);
    }

    swatchItemHtml(item, additionalClass = "" ){
        return `
            <a href="${item.url}" class="color-variant${additionalClass}">
              <img src="${item.image_cropped || item.image}" alt="${item.title}" class="motion-reduce" width="74" height="74" loading="lazy" />
            </a>
        `;
    }
}

document.addEventListener("DOMContentLoaded", () => new ColorSwatches());